import DM from 'DM';
import QGraphTracker from './qGraph.js';
import WPPixelTracker from './wppixel.js';
import RtbTracker from './rtb.js';
import ExternalTrackers from './external-trackers.js';
import TiktokTracker from "./tiktok";
import MicrosoftTracker from "./microsoft";

const trackers = new ExternalTrackers();

const qGraphTracker = new QGraphTracker();
const wppixelTracker = new WPPixelTracker();
const rtbTracker = new RtbTracker();
const tiktokTracker = new TiktokTracker();
const microsoftTracker = new MicrosoftTracker();

trackers.register(qGraphTracker);
trackers.register(wppixelTracker);
trackers.register(rtbTracker);
trackers.register(tiktokTracker);
trackers.register(microsoftTracker);

DM.ExternalTrackers = trackers;

export default trackers;
